import React from 'react';
import { reduxForm, Field } from 'redux-form';
import InputField from './InputField';
import SelectField from './SelectField';
import { formatSaveStatus } from '../helpers/formatters';
import listItemPlans from '../helpers/listItemPlans';

const AddLineItemsForm = ({
  handleSubmit,
  saveStatus,
  onSelectChange,
  isAttChosen,
  isSimoChosen,
  isQuickChosen,
  isAllChosen,
}) => (
  <div>
    <form onSubmit={handleSubmit}>
      <Field
        component={SelectField}
        name="item_type"
        label="Item type*"
        options={listItemPlans.map((plan) => [plan.value, plan.name])}
        empty="Select item type"
        onChange={onSelectChange}
      />
      <Field
        component={InputField}
        type="number"
        min="0"
        step="1"
        pattern="[0-9]+"
        title="please enter number only"
        name="item_id"
        label="Item id"
      />
      {(isAttChosen || isAllChosen) && (
        <Field
          component={InputField}
          type="number"
          min="0"
          step="1"
          pattern="[0-9]+"
          title="please enter number only"
          name="att_subscription_id"
          label="Att subscription id"
        />
      )}
      {(isQuickChosen || isAllChosen) && (
        <Field
          component={InputField}
          type="number"
          min="0"
          step="1"
          pattern="[0-9]+"
          title="please enter number only"
          name="quick_subscription_id"
          label="Quick subscription id"
        />
      )}
      {(isSimoChosen || isAllChosen) && (
        <Field
          component={InputField}
          type="number"
          min="0"
          step="1"
          pattern="[0-9]+"
          title="please enter number only"
          name="simo_subscription_id"
          label="Simo subscription id"
        />
      )}
      <Field
        component={InputField}
        type="number"
        min="1"
        step="1"
        pattern="[0-9]+"
        title="please enter number only"
        name="quantity"
      />

      <button className="btn btn-default" disabled={saveStatus === 'PENDING'}>
        Add line items
      </button>

      <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
    </form>
  </div>
);

const validate = (values, { itemType }) => {
  let errors = {};

  if (!values.item_type) {
    errors.item_type = 'Required';
  }
  if (!values.item_id && itemType !== 'mdn_change_fee') {
    errors.item_id = 'Required';
  }

  return errors;
};

export default reduxForm({
  form: 'addLineItems',
  validate,
})(AddLineItemsForm);
